import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'
import Container from 'react-bootstrap/Container'
import { useState } from 'react'
import NewDateFromDeck from '../pages/newDateFromDeck'


const ShuffleIdeaComp = (props) => {
    const idea = props.mods.shuffledIdea

    const [detailsToggle, setDetailsToggle] = useState(false)
    const [newDateToggle, setNewDateToggle] = useState(false)

    function handleDetailsToggle() {
        if (detailsToggle) {
            setDetailsToggle(false)
        } else {
            setDetailsToggle(true)
        }
    }

    function openNewDate() {
        setNewDateToggle(true)
    }

    return (
        <div className="ideaItem ideaContainer mt-2">
            <Container>
                {newDateToggle ? <NewDateFromDeck mods={{setNewDateToggle, idea}} /> : null}
                    <Row>
                        <Col xs={5}>
                            <h4>{idea.name}</h4>
                        </Col>
                        <Col>
                            <Button onClick={openNewDate} className="btn-dark defaultButton altDateButton">Schedule</Button>
                        </Col>
                    </Row>
                    <Row>
                    <Col>
                        <h6>Location: {idea.location}</h6>
                        {!detailsToggle ? <p type="button" className="bottomCenter" onClick={handleDetailsToggle}>more<i className="bi bi-chevron-compact-down"></i></p> : null}
                    </Col>
                    </Row>
                    {detailsToggle ? 
                        <>
                            <Row>
                                <Col><p>Details: {idea.details}</p></Col>
                                <Col>
                                    <p type="button" className="bottomCenter" onClick={handleDetailsToggle}>less<i className="bi bi-chevron-compact-up"></i></p>
                                </Col>
                            </Row>
                        
                        </>
                        : null
                    }
                    </Container>
                </div>
    )
}

export default ShuffleIdeaComp